module.exports = __webpack_public_path__ + "static/media/Timed_Bonus_Open@3x.1fb713d4.png";